// extracted by mini-css-extract-plugin
export default {"link":"_1lQEwq1qRB","primary":"PDjHvZc2FC","secondary":"_2fiyoScOu6","link-visited":"_2UGJbucmEo","linkVisited":"_2UGJbucmEo","disabled":"_3hMf6s3pMQ","icon":"_1BwTpYCbQS","doc-icon":"lsOtMxF3Bu","docIcon":"lsOtMxF3Bu"};
    if(module.hot) {
      // 1627035456498
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  